<template>
    <div>
        <template v-for="(item, index) in items" :key="index">
            <div class="divider" v-if="item.type === 'divider'" :key="`divider${index}`" />
            <menu-item
                v-else
                :editor="editor"
                :icon="item.icon"
                :title="item.title"
                :action="item.action"
            />
        </template>

        <!-- Ajoutez les composants modaux -->
        <LinkWindow :editor="editor" :isOpen="isLinkWindowOpen" @close="closeLinkWindow" />
        <ImageWindow :editor="editor" :isOpen="isImageWindowOpen" @close="closeImageWindow" />
    </div>
</template>

<script lang="ts">
import { createApp } from "vue";
import MenuItem from "./MenuItem.vue";
import LinkWindow from "./LinkWindow.vue";
import ImageWindow from "./ImageWindow.vue";

interface MenuItem {
    type?: string; // Optionnel pour les éléments de type "divider"
    icon?: string; // Optionnel pour les éléments de type "divider"
    title?: string; // Optionnel pour les éléments de type "divider"
    action?: () => void; // Optionnel pour les éléments de type "divider"
}

export default {
    components: {
        MenuItem,
        LinkWindow,
        ImageWindow,
    },
    props: {
        editor: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLinkWindowOpen: false,
            isImageWindowOpen: false,
            items: [
                {
                    icon: "bold",
                    title: "Gras",
                    action: () => this.editor.chain().focus().toggleBold().run(),
                },
                {
                    icon: "italic",
                    title: "Italique",
                    action: () => this.editor.chain().focus().toggleItalic().run(),
                },
                {
                    icon: "underline",
                    title: "Souligner",
                    action: () => this.editor.chain().focus().toggleUnderline().run(),
                },
                /*{
          icon: "strikethrough",
          title: "Strike",
          action: () => this.editor.chain().focus().toggleStrike().run(),
        },*/
                {
                    icon: "align-left",
                    title: "Aligner à gauche",
                    action: () => this.editor.chain().focus().setTextAlign("left").run(),
                },
                {
                    icon: "align-center",
                    title: "Centrer",
                    action: () => this.editor.chain().focus().setTextAlign("center").run(),
                },
                {
                    icon: "align-right",
                    title: "Aligner à droite",
                    action: () => this.editor.chain().focus().setTextAlign("right").run(),
                },
                {
                    icon: "align-justify",
                    title: "Justifier",
                    action: () => this.editor.chain().focus().setTextAlign("justify").run(),
                },
                /*{
          icon: "code-view",
          title: "Code",
          action: () => this.editor.chain().focus().toggleCode().run(),
        },*/
                {
                    icon: "mark-pen-line",
                    title: "Surligner",
                    action: () => this.editor.chain().focus().toggleHighlight().run(),
                },
                {
                    type: "divider",
                },
                {
                    icon: "h-1",
                    title: "Titre 1",
                    action: () => this.editor.chain().focus().toggleHeading({ level: 1 }).run(),
                },
                {
                    icon: "h-2",
                    title: "Titre 2",
                    action: () => this.editor.chain().focus().toggleHeading({ level: 2 }).run(),
                },
                {
                    icon: "h-3",
                    title: "Titre 3",
                    action: () => this.editor.chain().focus().toggleHeading({ level: 3 }).run(),
                },
                {
                    icon: "h-4",
                    title: "Titre 4",
                    action: () => this.editor.chain().focus().toggleHeading({ level: 4 }).run(),
                },
                {
                    icon: "text",
                    title: "Texte normal",
                    action: () => this.editor.chain().focus().setParagraph().run(),
                },
                {
                    icon: "list-unordered",
                    title: "Liste à pouces",
                    action: () => this.editor.chain().focus().toggleBulletList().run(),
                },
                {
                    icon: "list-ordered",
                    title: "Liste numérotée",
                    action: () => this.editor.chain().focus().toggleOrderedList().run(),
                },
                {
                    icon: "link", // Icône pour les liens
                    title: "Ajouter un lien",
                    action: () => this.openLinkWindow(),
                },
                {
                    icon: "image-fill", // Icône pour les images
                    title: "Insérer une image",
                    action: () => this.openImageWindow(),
                },
                /*{
          icon: "code-box-line",
          title: "Code Block",
          action: () => this.editor.chain().focus().toggleCodeBlock().run(),
        },
        {
          type: "divider",
        },
        {
          icon: "number-2",
          title: "Font size H2",
          action: () =>
            this.editor
              .chain()
              .focus()
              .updateAttributes("paragraph", { class: "text-2xl" })
              .run(),
        },
        {
          icon: "number-3",
          title: "Font size H3",
          action: () =>
            this.editor
              .chain()
              .focus()
              .updateAttributes("paragraph", { class: "text-xl" })
              .run(),
        },
        {
          icon: "number-4",
          title: "Font size H4",
          action: () =>
            this.editor
              .chain()
              .focus()
              .updateAttributes("paragraph", { class: "text-lg" })
              .run(),
        },
        {
          icon: "font-size",
          title: "Font size normal",
          action: () =>
            this.editor
              .chain()
              .focus()
              .updateAttributes("paragraph", { class: null })
              .run(),
        },*/
                {
                    type: "divider",
                },
                /*{
          icon: "add-box-line",
          title: "Success Box",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleDiv({ class: "alert-success" })
              .run(),
        },
        {
          icon: "checkbox-indeterminate-line",
          title: "Danger Box",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleDiv({ class: "alert-danger" })
              .run(),
        },
        {
          icon: "information-line",
          title: "Info Box",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleDiv({ class: "alert-info" })
              .run(),
        },
        {
          icon: "product-hunt-line",
          title: "Product Box",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleDiv({ class: "product-info" })
              .run(),
        },
        {
          icon: "checkbox-blank-line",
          title: "Summary Box",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleDiv({ class: "summary-box" })
              .run(),
        },
        {
          icon: "checkbox-blank-fill",
          title: "Primary Box",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleDiv({ class: "alert-primary" })
              .run(),
        },
        {
          icon: "checkbox-multiple-blank-fill",
          title: "Secondary Box",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleDiv({ class: "alert-secondary" })
              .run(),
        },
        {
          icon: "layout-bottom-line",
          title: "Intro Box",
          action: () => {
            this.editor
              .chain()
              .insertContentAt(
                this.editor.view.state.selection.anchor - 1,
                '<div class="intro-box"><div class="intro-box__summary"><p class="text-xl">...</p><ul><li>...</li></ul></div><div class="intro-box__how-to"><p class="text-xl">...</p><ul><li>...</li></ul></div></div>'
              )
              .focus()
              .run();
          },
        },
        {
          type: "divider",
        },
        {
          icon: "double-quotes-l",
          title: "Blockquote",
          action: () => this.editor.chain().focus().toggleBlockquote().run(),
        },
        {
          icon: "separator",
          title: "Horizontal Rule",
          action: () => this.editor.chain().focus().setHorizontalRule().run(),
        },
        {
          type: "divider",
        },
        {
          icon: "text-wrap",
          title: "Hard Break",
          action: () => this.editor.chain().focus().setHardBreak().run(),
        },
        {
          icon: "format-clear",
          title: "Clear Format",
          action: () =>
            this.editor.chain().focus().clearNodes().unsetAllMarks().run(),
        },
        {
          type: "divider",
        },
        {
          icon: "check-line",
          title: "Positive List",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleBulletClass("positive-list")
              .run(),
        },
        {
          icon: "close-line",
          title: "Negative List",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleBulletClass("negative-list")
              .run(),
        },
        {
          icon: "checkbox-blank-circle-line",
          title: "Neutral List",
          action: () =>
            this.editor.chain().focus().toggleBulletClass(null).run(),
        },
        {
          icon: "file-list-line",
          title: "Lean Navigation",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleBulletClass("page-lean-navigation")
              .run(),
        },
        {
          icon: "file-list-fill",
          title: "Page Navigation",
          action: () =>
            this.editor
              .chain()
              .focus()
              .toggleBulletClass("page__navigation")
              .run(),
        },
        {
          type: "divider",
        },
        {
          icon: "table-line",
          title: "Insert Table",
          action: () =>
            this.editor
              .chain()
              .focus()
              .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
              .run(),
        },
        {
          icon: "delete-bin-line",
          title: "Delete Table",
          action: () => this.editor.chain().focus().deleteTable().run(),
        },
        {
          icon: "insert-column-left",
          title: "Add Column Before",
          action: () => this.editor.chain().focus().addColumnBefore().run(),
        },
        {
          icon: "insert-column-right",
          title: "Add Column After",
          action: () => this.editor.chain().focus().addColumnAfter().run(),
        },
        {
          icon: "delete-column",
          title: "Delete Column",
          action: () => this.editor.chain().focus().deleteColumn().run(),
        },
        {
          icon: "insert-row-top",
          title: "Add Row Before",
          action: () => this.editor.chain().focus().addRowBefore().run(),
        },
        {
          icon: "insert-row-bottom",
          title: "Add Row After",
          action: () => this.editor.chain().focus().addRowAfter().run(),
        },
        {
          icon: "delete-row",
          title: "Delete Row",
          action: () => this.editor.chain().focus().deleteRow().run(),
        },
        {
          icon: "merge-cells-horizontal",
          title: "Merge Cells",
          action: () => this.editor.chain().focus().mergeCells().run(),
        },
        {
          icon: "split-cells-horizontal",
          title: "Split Cells",
          action: () => this.editor.chain().focus().splitCell().run(),
        },
        {
          icon: "arrow-left-right-line",
          title: "Merge or Split",
          action: () => this.editor.chain().focus().mergeOrSplit().run(),
        },
        {
          type: "divider",
        },
        {
          icon: "arrow-go-back-line",
          title: "Undo",
          action: () => this.editor.chain().focus().undo().run(),
        },
        {
          icon: "arrow-go-forward-line",
          title: "Redo",
          action: () => this.editor.chain().focus().redo().run(),
        },
        {
          type: "divider",
        },
        /*{
          icon: "code-line",
          title: "Source",
          action: () => this.openSourceWindow(),
        }*/
            ] as MenuItem[], // Utilisez le type MenuItem pour le tableau
        };
    },
    methods: {
        /*openLinkWindow() {
            const url = prompt("Entrez l'URL du lien"); // Demande à l'utilisateur de saisir une URL
            if (url) {
                this.editor.chain().focus().toggleLink({ href: url }).run(); // Applique le lien
            }
        },
        openImageWindow() {
            const url = prompt("Entrez l'URL de l'image"); // Demande à l'utilisateur de saisir une URL d'image
            if (url) {
                this.editor.chain().focus().setImage({ src: url }).run(); // Insère l'image
            }
        },*/
        openLinkWindow() {
            this.isLinkWindowOpen = true;
        },
        closeLinkWindow() {
            this.isLinkWindowOpen = false;
        },
        openImageWindow() {
            this.isImageWindowOpen = true;
        },
        closeImageWindow() {
            this.isImageWindowOpen = false;
        },
        /*
    openExternalVideoWindow() {
      const ExternalVideoCtor = Vue.extend(ExternalVideoWindow);
      const windowInstance = new ExternalVideoCtor({
        propsData: {
          editor: this.editor,
          attributes: isEmpty(this.editor.getAttributes("external-video"))
            ? null
            : this.editor.getAttributes("external-video"),
        },
      });
      windowInstance.$mount();
      document.querySelector("body").appendChild(windowInstance.$el);
    },
    openExternalIframeWindow() {
      const ExternalIframeCtor = Vue.extend(ExternalIframeWindow);
      const windowInstance = new ExternalIframeCtor({
        propsData: {
          editor: this.editor,
          attributes: isEmpty(this.editor.getAttributes("external-iframe"))
            ? null
            : this.editor.getAttributes("external-iframe"),
        },
      });
      windowInstance.$mount();
      document.querySelector("body").appendChild(windowInstance.$el);
    },
    openSourceWindow() {
      const SourceCtor = Vue.extend(SourceWindow);
      const windowInstance = new SourceCtor({
        propsData: {
          editor: this.editor,
    },
});
      windowInstance.$mount();
      document.querySelector("body").appendChild(windowInstance.$el);
    },
    */
    },
    mounted() {
        //
    },
};
</script>
